<template>
  <div>
    <LargeTitle />
    <MiddleTitle />
    <Contents />
    <Mail />
    <Btn />
  </div>
</template>

<script>
import LargeTitle from "@/components/LargeTitleStaff.vue";
import MiddleTitle from "@/components/MiddleTitleStaff.vue";
import Contents from "@/components/ContentsStaff.vue";
import Mail from "@/components/Mail.vue";
import Btn from "@/components/ButtonToTop.vue";

export default {
  components: {
    LargeTitle,
    MiddleTitle,
    Contents,
    Mail,
    Btn,
  },
};
</script>
